const keyMirror = require('fbjs/lib/keyMirror');

module.exports = keyMirror({
  ACTION_DELETE: null
});
